// Made by wirestorm - https://wirestorm.software
import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="intro-text">
                <h1>
                  This is manomaintenance
                  <span></span>
                </h1>
                <p>Need something fixed? We fix it fast no YouTube tutorials required.</p>
                <a
                  href="#about"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
// Made by wirestorm - https://wirestorm.software
